export const YANDEX_API_TELEMETRY_KEY = 'yandexApi.requestsCount';
